import { API_V4_BASE_URL } from 'settings';
import { toastError } from 'utils/reduxToast';
import { get } from './api';

export const fetchModules = (courseHash: string) => {
  return get({
    url: `/learner/course/${courseHash}/modules/v2`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Não foi possível carregar os módulos do curso no momento!'));
};
